module.exports = __webpack_public_path__ + "img/naosuke.691c4565.jpg";